import React, { useState, useContext, useEffect } from "react";
import { ApiUrlContext } from "../App";
import { useLocation, useHistory } from "react-router-dom";
import { auth } from "../firebase";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const apiUrl = useContext(ApiUrlContext);
  const query = useQuery();
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState({ loading: false, success: null, error: null });
  const [email, setEmail] = useState("");
  const token = query.get("token") || "";
  // Firebase uses oobCode in the querystring when sending reset links
  const oobCode = query.get("oobCode") || token || "";

  useEffect(() => {
    let mounted = true;
    async function verifyCode() {
      if (!oobCode) return;
      try {
        const resolvedEmail = await verifyPasswordResetCode(auth, oobCode);
        if (mounted) {
          setEmail(resolvedEmail);
        }
      } catch (err) {
        if (!mounted) return;
        setStatus({ loading: false, success: null, error: "Geçersiz veya süresi dolmuş bağlantı." });
      }
    }
    verifyCode();
    return () => { mounted = false; };
  }, [oobCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oobCode) {
      setStatus({ loading: false, success: null, error: "Geçersiz bağlantı veya token." });
      return;
    }
    if (password.length < 8) {
      setStatus({ loading: false, success: null, error: "Şifre en az 8 karakter olmalı." });
      return;
    }
    if (password !== confirm) {
      setStatus({ loading: false, success: null, error: "Şifreler eşleşmiyor." });
      return;
    }
    setStatus({ loading: true, success: null, error: null });
    try {
      // Confirm password reset using Firebase client SDK
      await confirmPasswordReset(auth, oobCode, password);
      await fetch(`${apiUrl}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      setStatus({ loading: false, success: "Şifreniz başarıyla güncellendi. Giriş yapabilirsiniz.", error: null });
      setPassword("");
      setConfirm("");
      setTimeout(() => history.push("/"), 2500);
    } catch (err) {
      console.error("confirmPasswordReset error:", err);
      setStatus({ loading: false, success: null, error: "Şifre sıfırlama işlemi başarısız oldu." });
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #e0e7ff 0%, #f7f7f7 100%)", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 370, background: "#fff", padding: "32px 20px", borderRadius: 18, boxShadow: "0 4px 24px #0002", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ fontSize: 32, fontWeight: 800, color: "#3b3b99", marginBottom: 8, letterSpacing: 1 }}>Yeni Şifre Belirle</div>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            placeholder="Yeni şifreniz"
            style={{ width: "100%", padding: 10, borderRadius: 8, border: "1px solid #d1d5db", fontSize: 15, outline: "none", background: "#f5f7fa", marginBottom: 12 }}
          />
          <input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            required
            placeholder="Yeni şifre (tekrar)"
            style={{ width: "100%", padding: 10, borderRadius: 8, border: "1px solid #d1d5db", fontSize: 15, outline: "none", background: "#f5f7fa", marginBottom: 16 }}
          />
          <button
            type="submit"
            disabled={status.loading}
            style={{ width: "100%", padding: "12px 0", background: "linear-gradient(90deg, #6366f1 0%, #3b3b99 100%)", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 17, letterSpacing: 1, marginTop: 4, boxShadow: "0 2px 8px #6366f122", cursor: "pointer", transition: "background 0.2s" }}
          >
            {status.loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
          </button>
        </form>
        {status.error && <div style={{ color: "#e53935", marginTop: 14, background: "#ffeaea", padding: "8px 12px", borderRadius: 6, fontSize: 14 }}>{status.error}</div>}
        {status.success && <div style={{ color: "#16a34a", marginTop: 14, background: "#eaffea", padding: "8px 12px", borderRadius: 6, fontSize: 14 }}>{status.success}</div>}
      </div>
    </div>
  );
}
